import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { Button, Table, Form } from 'react-bootstrap';
import { BsFillEyeFill, BsChevronBarExpand } from "react-icons/bs";
import { useNavigate} from 'react-router-dom';


function Items({ currentItems }) {
    const navigate = useNavigate();
    function detailsReception(id){
        navigate('/Detalles', {state: {id: id}});
    }
    return (
        <>
        {currentItems &&
            currentItems.map((elem) => (
                <tr key={elem.idRecepcion} className='centerData'>
                    <td>{elem.fecha}</td>
                    <td>{elem.idRecepcion}</td>
                    <td>{elem.totalCerdos}</td>
                    <td>{elem.totalKilos}</td>
                    <td>{elem.rendimiento}</td>
                    <td><Button variant='secondary' onClick={detailsReception.bind(this, elem.idRecepcion)}><BsFillEyeFill/></Button></td>
                </tr>
            ))
        }
        </>
    );
}
export default Items

export function PaginatedItems({ data }) {
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [currentItems, setCurrentItems] = useState(null);
    const [renderCurrent, setRenderCurrent] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    
    const [itemOffset, setItemOffset] = useState(0);

    const [sort, setSort] = useState(true);
    useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(data.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(data.length / itemsPerPage));
        setRenderCurrent(true);
    }, [itemOffset, itemsPerPage]);

    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % data.length;
        setItemOffset(newOffset);
    };
    
    const handleChange = (event) =>{
        setItemsPerPage(event.target.value);
    }

    function setStateAsync(state) {
        setRenderCurrent(state)
    }

    async function ascToDesc(){
        await setStateAsync(false);
        const items = currentItems;
        if(sort){
            setCurrentItems(items.sort(compare));
            setSort(false);
        }else{
            setCurrentItems(items.sort(compare2));
            setSort(true);
        }
        await setStateAsync(true);
    }

    function compare( a, b ) {
        if ( a.fecha < b.fecha ){
            return -1;
        }
        if ( a.fecha > b.fecha ){
            return 1;
        }
        return 0;
    }
    
    function compare2( a, b ) {
        if ( a.fecha > b.fecha ){
            return -1;
        }
        if ( a.fecha < b.fecha ){
            return 1;
        }
        return 0;
    }

    return (
        <>
        <div className='gridData'>
            <Table striped bordered hover variant>
                <thead>
                    <tr>
                    <th>Fecha<Button variant='Light' color="black" onClick={ascToDesc.bind()}><BsChevronBarExpand/></Button></th>
                    <th>Id Recepción</th>
                    <th>Total Cerdos</th>
                    <th>Total Kilos</th>
                    <th>% Rendimiento</th>
                    <th>Detalle</th>
                    </tr>
                </thead>
                <tbody>
                    {renderCurrent && <Items currentItems={currentItems}/>}
                </tbody>
            </Table>
            <div className='navigation'>
                <ReactPaginate
                    nextLabel="siguiente >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={2}
                    pageCount={pageCount}
                    previousLabel="< anterior"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination justify-content-center"
                    activeClassName="active"
                    renderOnZeroPageCount={null}
                />
                <Form.Select className='formSelect' defaultValue="10" onChange={handleChange}>
                    <option >10</option>
                    <option>20</option>
                    <option>30</option>
                    <option>40</option>
                    <option>50</option>
                </Form.Select>
            </div>
        </div>
        </>
    );
}

